export const en = {
  // Navigation
  navigation: {
    dashboard: 'Dashboard',
    profiles: 'Profiles',
    reports: 'Reports',
    sites: 'Sites',
    settings: 'Settings',
    account: 'Account',
    logout: 'Logout',
    switchAccount: 'Switch Account',
    accountSettings: 'Account Settings',
    events: 'Events',
    users: 'Users',
    allEvents: 'All Events',
    eventGenerator: 'Event Generator',
    reportingHub: 'Reporting Hub',
    musterReport: 'Muster Report',
    anomalies: 'Anomalies',
    peopleOnSite: 'People On Site',
    userTimeAndAttendance: 'User Time and Attendance',
    companyTimeAndAttendance: 'Company Time and Attendance',
    companyTimeAndAttendanceGroups: 'Company Time and Attendance Groups',
    expiringProfiles: 'Expiring Profiles & Certificates',
    firstInLastOut: 'First In / Last Out',
    boscaAdminDailyProfiles: 'Daily profiles on site',
    boscaAdminDailyCompanies: 'Companies by day',
    deletedProfiles: 'Deleted Profiles',
    manageProfiles: 'Manage Profiles',
    poweredBy: 'Powered by...',
    integrations: 'Integrations',
    procoreExplorer: 'Procore Explorer',
    visitors: 'Visitors',
    visitorAttendance: 'Visitor Attendance',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    overview: 'Overview',
    welcomeBack: 'Welcome back',
    hi: 'Hi',
    onlineSites: 'Online sites',
    profilesOnSitesNow: 'Profiles on sites now',
    events: 'Events',
    profileActivity: 'Profile Activity',
    uniqueProfilesPerDay: 'Unique profiles per day',
    peopleOnSite: 'People on site',
    gatesOnline: 'Gates online',
    notifications: 'Notifications',
    activityOverview: 'Activity overview',
    actions: 'Actions',
    chooseASite: 'CHOOSE A SITE',
    toViewAndMakeActions: 'to view and make actions',
    registerAProfile: 'Register a Profile',
    manageProfiles: 'Manage Profiles',
    manageDoors: 'Manage Doors',
    holdOpenAllDoors: 'Open All Doors',
    openAllDoors: 'Open All Doors',
    closeAllDoors: 'Close All Doors',
    confirmHoldOpenTitle: 'Open all doors?',
    confirmHoldOpenMessage: 'All doors will remain open until someone resets them using Reset All Doors.',
    cancel: 'Cancel',
    sitesAreOpen: 'Warning: Sites are open',
    openSince: 'Open since',
    siteOpenAlertClickHint: 'Click to go to Manage Doors',
    musterReport: 'Muster Report',
    period: 'Period',
    peopleOnAllSites: 'People on all sites',
    totalCompaniesOnSites: 'Total companies on sites',
    activities: 'Activities',
    entered: 'entered',
    left: 'left',
    justNow: 'Just now',
    hour: 'hour',
    hours: 'hours',
    ago: 'ago',
    today: 'Today',
    yesterday: 'Yesterday',
    piperSquare: 'piper square',
    // Overview page
    lastUpdated: 'Last updated',
    live: 'Live',
    todaysActivity: "Today's Activity",
    vsYesterday: 'vs yesterday',
    activityTrends: 'Activity Trends',
    activityTrendsSubheader: 'Unique profiles per day across all sites (last 7 days)',
    peopleBySite: 'People by Site',
    peopleBySiteSubheader: 'Current distribution across sites',
    peopleByCompany: 'People by Company',
    companiesOnSite: 'companies on site',
    moreCompanies: 'more companies',
    noSitesWithActiveProfiles: 'No sites with active profiles',
    noCompaniesWithActiveProfiles: 'No companies with active profiles',
    alertsAndInsights: 'Alerts & Insights',
    issuesRequiringAttention: 'Issues requiring attention',
    expiringProfiles: 'Expiring Profiles',
    expiringCertificates: 'Expiring Certificates',
    errors24h: 'Errors (24h)',
    warnings24h: 'Warnings (24h)',
    allSystemsHealthy: 'All systems healthy - no issues detected',
    person: 'person',
    people: 'people',
    profiles: 'profiles',
  },

  // Account Popover
  accountPopover: {
    accountSettings: 'Account Settings',
    switchAccount: 'Switch Account',
    logout: 'Logout',
    email: 'Email',
    account: 'Account',
  },

  // Site Selector
  siteSelector: {
    site: 'Site',
    allSites: 'All Sites',
  },

  // Language
  language: {
    english: 'English',
    german: 'German',
    language: 'Language',
    changeLanguage: 'Change Language',
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    youHaveUnreadMessages: 'You have {count} unread messages',
    markAllAsRead: 'Mark all as read',
    new: 'New',
    beforeThat: 'Before that',
    viewAll: 'View All',
    // Sample notification messages
    yourOrderIsPlaced: 'Your order is placed',
    waitingForShipping: 'waiting for shipping',
    answeredToYourComment: 'answered to your comment on the Minimal',
    youHaveNewMessage: 'You have new message',
    unreadMessages: '5 unread messages',
    youHaveNewMail: 'You have new mail',
    sentFrom: 'sent from Guido Padberg',
    deliveryProcessing: 'Delivery processing',
    yourOrderIsBeingShipped: 'Your order is being shipped',
  },

  // Common
  common: {
    create: 'Create',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    refresh: 'Refresh',
    search: 'Search',
    searchPlaceholder: 'Search...',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    noData: 'No data',
    notAvailable: '-',
    dashboard: 'Dashboard',
  },

  // Login splash
  login: {
    pageTitle: 'Sign in | CloudLoq',
    signIn: 'Sign in',
    tryAgain: 'Try again',
    errorDescription: 'Something went wrong while starting sign-in. Please try again.',
  },

  // Profiles
  profiles: {
    title: 'Profiles',
    sitesProfiles: 'Sites profiles',
    siteLabel: 'Site',
    refreshProfiles: 'Refresh Profiles',
    tabs: {
      local: 'Local Profiles',
      skillkoReadyShort: 'Skillko - Ready',
      skillkoReadyLong: 'Skillko - Ready for Registration',
      skillkoNotReady: 'Skillko - Not Ready',
      sitepassShort: 'SitePass',
      sitepassReadyLong: 'SitePass - Ready for Registration',
      deleted: 'Deleted Profiles',
    },
    searchProfiles: 'Search Profiles',
    searchMinCharsPlaceholder: 'Please enter 3 or more characters',
    crossTabSearch: {
      alsoFoundIn: 'Also found in',
      matchCount: '{count} in {tab}',
      noResultsHere: 'No profiles on this tab match your search.',
    },
    registerNewProfile: 'Register New Profile',
    registerNewProfileWithoutSkillko: 'Register new profile (skip Skillko)',
    importDraftProfiles: 'Import Draft Profiles',
    info: {
      localManaged: 'Local profiles managed directly in CloudLoq',
      deletedAll:
        'Deleted profiles - View all profiles that have been deleted from the system',
      skillkoReady: 'Skillko profiles ready for registration',
      skillkoNotReady:
        'Skillko profiles that need additional requirements before registration',
      sitepassReady: 'SitePass profiles ready for registration',
    },
    skillkoReady: {
      noPhotoHint: 'No profile photo in Skillko',
      noPhotoRibbon: 'No photo',
    },
    badge: {
      skillko: 'Skillko',
      skillkoTooltip: 'Profile synced from Skillko',
      skillkoMerge: 'Can merge from Skillko',
      skillkoMergeTooltip: 'A matching Skillko profile is ready for induction',
      skillkoMergeTooltipWithTeam: 'Skillko match: {teamName} (ID {skillkoId})',
    },
    card: {
      noAccessLevel: 'No access level',
      deletedProfile: 'Deleted Profile',
      deletedAt: 'Deleted',
      notReadyForRegistration: 'Not Ready For Registration',
      requirementsNotMet: 'Requirements not met',
      unknownReason: 'Unknown reason',
      failedRules: 'Failed Rules',
      failureReason: 'Failure Reason',
      view: 'View',
      noProfiles: 'No profiles to display',
      noProfilesDescription:
        'No profiles match your current filters or search criteria.',
    },
    table: {
      profile: 'Profile',
      firstName: 'First Name',
      lastName: 'Last Name',
      company: 'Company',
      skillkoTeam: 'Skillko Team',
      status: 'Status',
      access: 'Access',
      reasons: 'Reasons',
      source: 'Source',
      actions: 'Actions',
      teamUnavailable: '-',
      showMoreRules: '+{count} more',
      allValidationIssues: 'All Validation Issues',
    },
    snackbar: {
      loadLocalFailed: 'Failed to load local profiles',
      loadDeletedFailed: 'Failed to load deleted profiles',
      loadSkillkoFailed: 'Failed to load Skillko profiles',
      loadSitepassFailed: 'Failed to load SitePass profiles',
      skillkoThisProfile: 'This profile',
      skillkoRefreshing: 'Refreshing {name} from Skillko…',
      skillkoRefreshSuccess: '{name} is up to date with Skillko.',
      skillkoRefreshFailed: "Couldn't refresh {name} from Skillko.",
      skillkoMovedToReady: '{name} is now ready for registration.',
      skillkoMovedToNotReady: '{name} is no longer ready for registration.',
      skillkoStillNotReady: '{name} is up to date with Skillko, but still not ready for registration.',
    },
    actionsMenu: {
      openInSkillko: 'Open in Skillko',
      register: 'Register',
      resetAntipassback: 'Reset AntiPassback',
      resetAntipassbackSuccess: 'Anti-passback reset successfully.',
      resetAntipassbackFailed: 'Failed to reset anti-passback.',
      mergeWithSkillko: 'Merge with Skillko',
      linkToSkillko: 'Link to Skillko',
      refreshFromSkillko: 'Refresh from Skillko',
    },
    linkDialog: {
      title: 'Link profile to Skillko',
      description:
        "Enter the numeric Skillko user ID. The profile's email in CloudLoq must match the Skillko user's email, or the link will be rejected. After linking, data is synced from Skillko (same as force sync).",
      skillkoIdLabel: 'Skillko profile ID',
      skillkoIdPlaceholder: 'e.g. 12345',
      skillkoAutomaticExpiry: 'Use Skillko automatic expiry for this profile',
      confirm: 'Link and sync',
      invalidSkillkoId: 'Enter a valid Skillko profile ID (positive whole number).',
      success:
        'Profile linked to Skillko and synced. The site profile email must match the Skillko user — certificates and readiness follow Skillko data.',
      failed: 'Failed to link profile to Skillko.',
    },
    mergeDialog: {
      title: 'Merge with Skillko',
      description:
        'This links the local UI profile to the matching Skillko user and syncs certificates and readiness from Skillko. Review the changes below before confirming.',
      skillkoMatch: 'Skillko match: {name} — {teamName} (ID {skillkoId})',
      columns: {
        field: 'Field',
        before: 'Current',
        after: 'After merge',
      },
      fields: {
        source: 'Source',
        integrationId: 'Skillko integration',
        firstName: 'First name',
        lastName: 'Last name',
        certificates: 'Certificates',
      },
      certificatesAdded: '{count} certificate(s) will be synced from Skillko: {names}',
      afterMergeNote:
        'After merge, this profile will be linked to Skillko and the duplicate will disappear from the Skillko Ready tab.',
      skillkoAutomaticExpiry: 'Use Skillko automatic expiry for this profile',
      confirm: 'Merge and sync',
      loadFailed: 'Failed to load merge preview.',
      success: 'Profile merged with Skillko and synced successfully.',
      failed: 'Failed to merge profile with Skillko.',
    },
    importDialog: {
      firstNameRequired: 'First Name is required',
      lastNameRequired: 'Last Name is required',
      parseFailed: 'Failed to parse CSV',
      noProfilesToImport: 'No profiles to import',
      fixValidationErrors: 'Please fix validation errors before importing',
      queueSuccess: 'Successfully queued {count} profiles for import',
      importFailed: 'Failed to import profiles',
      dateOfBirth: 'Date of Birth',
      phone: 'Phone',
      safePassExpiry: 'SafePass Expiry',
      manualHandlingExpiry: 'Manual Handling Expiry',
      error: 'Error',
      valid: 'Valid',
      csvInstructions:
        'Upload a CSV file with the following columns: First Name, Last Name, Email, date of birth, Contact Number, SafePass/CSR Expiry, Manual Handling Expiry, Company Name',
      selectCsvFile: 'Select CSV File',
      validProfiles: 'valid profiles',
      profilesWithErrors: 'profiles with errors - please fix before importing',
      validationErrorsInRows: 'Validation errors found in {count} row(s):',
      row: 'Row',
      andMoreErrors: 'and {count} more errors',
      preview: 'Preview',
      validProfilesOutOf: 'valid profiles out of {count}',
      selectCsvToPreview: 'Select a CSV file to preview profiles',
      import: 'Import',
    },
    form: {
      pageTitleCreate: 'Create profile | CloudLoq',
      pageTitleEdit: 'Edit profile | CloudLoq',
      pageTitleView: 'View profile | CloudLoq',
      pageTitleRegister: 'Register a profile | CloudLoq',
      pageTitleRegisterSitepass: 'Register SitePass Profile | CloudLoq',
      breadcrumbAddNew: 'Add a new profile',
      breadcrumbEdit: 'Edit Profile',
      breadcrumbView: 'View Profile',
      breadcrumbRegister: 'Register a profile',
      breadcrumbRegisterSitepass: 'Register SitePass Profile',
      newProfile: 'New Profile',
      profile: 'Profile',
      newSitepassProfile: 'New SitePass Profile',
      retryInductionSuccess:
        'Retry induction initiated successfully. The profile will be processed shortly.',
      retryInductionFailed: 'Failed to retry induction',
      activating: 'Activating...',
      activateProfile: 'Activate Profile',
      deleteProfileTooltip:
        'You can delete the profile and start again by creating a new profile if necessary',
      deleteProfile: 'Delete profile',
      retryInductionTooltip: 'Retry the induction process for this profile',
      retrying: 'Retrying...',
      retryInduction: 'Retry Induction',
      refreshFromSkillko: 'Refresh from Skillko',
      refreshFromSkillkoTooltip:
        'Pull the latest profile and certificate data from Skillko and update this form.',
      refreshingFromSkillko: 'Refreshing...',
      refreshFromSkillkoSuccess: 'Skillko data refreshed successfully.',
      refreshFromSkillkoFailed: 'Failed to refresh data from Skillko.',
      forceUpdateFromSkillko: 'Force update from Skillko',
      forceUpdateFromSkillkoTooltip:
        'Admin only. Overwrites the stored Skillko profile, then updates every field on this registered profile that differs.',
      forcingUpdateFromSkillko: 'Updating...',
      forceUpdateFromSkillkoSuccess: 'Updated from Skillko: {fields}.',
      forceUpdateFromSkillkoUnchanged:
        'Skillko profile overwritten. This registered profile already matches.',
      forceUpdateFromSkillkoFailed: 'Failed to force update from Skillko.',
      forceUpdateFromSkillkoConfirmTitle: 'Force update from Skillko?',
      forceUpdateFromSkillkoConfirmBody:
        'This overwrites the stored Skillko profile from Skillko, then updates this registered profile wherever name, phone, date of birth, emergency contact, company, role, photo, expiry, or certificates differ. Email is left unchanged.',
      forceUpdateFromSkillkoConfirm: 'Force update',
      unableActivate: 'Unable to Activate Profile:',
      unableSaveDraft: 'Unable to Save as Draft:',
      unableSaveChanges: 'Unable to Save Changes:',
      pictureProcessingErrorTitle: 'Profile Picture Processing Error:',
      pictureProcessingErrorBody:
        'There was an issue processing your profile picture during registration. Simply upload a new profile picture and the system will automatically retry the process to ensure proper facial recognition functionality.',
      notReadyForInduction: 'Profile Not Ready for Induction',
      notReadyDescription:
        "This profile doesn't meet all induction requirements. You can still register them, but they may not have all required qualifications. The expiry date has been set to 1 month from now.",
      inductionExpiryPassed: 'Induction Expiry Passed',
      inductionExpiredOn: "This profile's induction expired on",
      verifyBeforeProceeding: 'Please verify the information before proceeding.',
      tabs: {
        editProfile: 'Edit Profile',
        viewProfile: 'View Profile',
        profileActivities: 'Profile Activities',
        changeHistory: 'Change History',
      },
      deletedReadOnly: 'This profile has been deleted. All fields are read-only and cannot be edited.',
      viewOnlyCannotRegister:
        'You can view this record, but you do not have permission to register or edit a profile.',
      confirmDeleteTitle: 'Confirm Delete Profile',
      confirmDeleteDescriptionPrefix: 'Are you sure you want to delete the profile for',
      confirmDeleteDescriptionSuffix: 'This action cannot be undone.',
      delete: 'Delete',
      skillkoFieldBadgeTooltip:
        'Synced from Skillko - update it there so your change is not overwritten on the next sync.',
      skillkoBannerText:
        'This profile is managed by Skillko. Fields marked with the cloud icon are normally kept in sync with Skillko every 15 minutes - changes made here may be overwritten. For permanent changes, update the data in Skillko, or refresh Skillko data to pull the latest information.',
      skillkoEditConfirmTitle: 'Editing Skillko-managed data',
      skillkoEditConfirmBody:
        '{fields} is normally kept in sync with Skillko. Saving this change here may be overwritten the next time this profile syncs with Skillko.',
      skillkoEditConfirmHint:
        'For a permanent change, update this information in Skillko instead. Or, if you want to discard your local edit and pull the latest data, refresh Skillko data now.',
      skillkoEditSaveAnyway: 'Save anyway',
      fieldFirstName: 'First name',
      fieldSurname: 'Surname',
      fieldDateOfBirth: 'Date of birth',
      fieldPhone: 'Phone',
      fieldNextOfKin: 'Emergency contact name',
      fieldNextOfKinPhone: 'Emergency contact number',
      fieldCompany: 'Company',
      fieldRole: 'Role',
      fieldPicture: 'Profile picture',
      fieldExpiry: 'Expiry date',
    },
  },

  // Account
  account: {
    loadingAccounts: 'Loading accounts...',
    noAccessTitle: 'No Access Available',
    noAccessDescription:
      "You don't have access to any accounts. Please contact your administrator to request access.",
    createAccount: 'Create Account',
    signOut: 'Sign Out',
    chooseAccountToLogin: 'Choose account to login',
    accountName: 'Account Name',
    allowedDomainsOptional: 'Allowed Domains (optional)',
    accountNameHelper: '3-64 chars, letters/numbers/spaces/-/_',
    domainsHelper: 'Comma-separated, e.g. @acme.com,@partner.com',
    domainsMustStartWithAt: 'Each domain must start with @',
    accountCreatedSuccessfully: 'Account created successfully',
    failedToCreateAccount: 'Failed to create account',
    cloudloqLogo: 'CloudLoq Logo',
    settings: {
      general: 'General',
      security: 'Security',
      domainAccessDescription: 'Configure domain-based access control for this account',
      allowedDomainsHelper:
        'Comma-separated list of allowed email domains (e.g., @acme.com, @partner.com). Users will only see this account if their email matches one of these domains. Leave empty to restrict to whitelisted admins only.',
      saveDomains: 'Save Domains',
    },
  },

  // Sites
  sites: {
    all: 'All',
    skillko: {
      title: 'Skillko Settings',
      failedLoadCertificates: 'Failed to load certificates',
      siteIdRequired: 'Site ID is required',
      loginRequired: 'Please log in to access this page',
      siteDataNotFound: 'Site data not found',
      failedInitializePage: 'Failed to initialize page',
      unknownError: 'Unknown error',
      errorLoadingPageData: 'Error loading page data',
      accessRules: 'Access Rules',
      expiryRule: 'Expiry Rule',
      enableAutoExpiryTitle: 'Enable Auto Expiry for All Skillko Profiles',
      enableAutoExpiryMessage:
        'This will enable automatic expiry date calculation for ALL non-deleted Skillko-sourced profiles on this site and recalculate their expiry dates. This is a one-time bulk action and cannot be undone. Continue?',
      autoExpiryQueued:
        'Auto expiry has been queued. All Skillko profiles on this site will be updated in the background.',
      failedEnableAutoExpiry: 'Failed to enable auto expiry',
      recalculateInductionTitle: 'Recalculate induction readiness for this site',
      recalculateInductionMessage:
        'This queues a full recalculation of Skillko access induction rules for every team on this site. Profile readiness flags will be updated in the background. Continue?',
      inductionRecalculationQueued:
        'Induction recalculation has been queued. It may take a few minutes to complete.',
      failedQueueRecalculation: 'Failed to queue induction recalculation',
    },
    administrative: {
      bulkRetrySectionTitle: 'Bulk retry profile induction',
      bulkRetrySectionIntro:
        'Queues one induction retry per matching site profile (must have a linked tenant profile). Retries are staggered by about 0.5 seconds each to reduce load on the site access controller.',
      bulkRetryStatusesLabel: 'Profile statuses to include',
      bulkRetryStatusesHint:
        'Only profiles that are not soft-deleted and whose status is in this list are included. Enum names match the server (e.g. InductionFailed).',
      bulkRetryQueueButton: 'Queue bulk retry',
      bulkRetryConfirmTitle: 'Queue bulk induction retries?',
      bulkRetryConfirmWarning:
        'This can generate many requests to the site box over time. Make sure the access system can handle the load.',
      bulkRetryConfirmStatuses: 'Statuses that will be matched:',
      bulkRetryConfirmAction: 'Queue retries',
      bulkRetrySuccess: 'Queued {enqueued} induction retries. They will run staggered in the background.',
      bulkRetryFailed: 'Failed to queue bulk induction retries',
      bulkRetrySelectStatus: 'Select at least one profile status',
      pipelineSideBySideTitle: 'Profile vs FaceScanner (same day)',
      pipelineSideBySideIntro:
        'Load rows from the standard Profile tables and the FaceScanner mirror tables for one calendar day. Both sides use the same server-side sort. Large days are capped.',
      pipelineDayLabel: 'Tracking day',
      pipelineEntityLabel: 'Dataset',
      pipelineEntityActivity: 'Profile activity',
      pipelineEntityState: 'Profile state tracking',
      pipelineEntityAnomaly: 'Profile activity anomalies',
      pipelineSortLabel: 'Sort by',
      pipelineSortProfileId: 'ProfileId',
      pipelineSortEventTimeUtc: 'EventTimeUtc (activity)',
      pipelineSortZoneId: 'ZoneId (state)',
      pipelineSortAnomalyName: 'AnomalyName (anomalies)',
      pipelineLoadButton: 'Load tables',
      pipelineLoadingFailed: 'Failed to load pipeline comparison',
      pipelineProfileTableTitle: 'Profile (standard)',
      pipelineFaceScannerTableTitle: 'FaceScanner',
      pipelineSortApplied: 'Sort applied: {field}',
      pipelineRowCap: 'Row cap per table: {cap}',
      pipelineTruncatedProfile: 'Profile table truncated at the row cap.',
      pipelineTruncatedFaceScanner: 'FaceScanner table truncated at the row cap.',
      pipelineNoRows: 'No rows',
      pipelineColId: 'Id',
      pipelineColProfileId: 'ProfileId',
      pipelineColProfileFullName: 'Name',
      pipelineColZoneId: 'ZoneId',
      pipelineColZoneName: 'Zone',
      pipelineColDoorId: 'DoorId',
      pipelineColActivityType: 'ActivityType',
      pipelineColEventTimeUtc: 'EventTimeUtc',
      pipelineColTimeInUtc: 'TimeInUtc',
      pipelineColTimeOutUtc: 'TimeOutUtc',
      pipelineColDoorControllerUserId: 'DoorControllerUserId',
      pipelineColHash: 'Hash',
      pipelineColOnSite: 'OnSite',
      pipelineColLastInUtc: 'LastInUtc',
      pipelineColLastOutUtc: 'LastOutUtc',
      pipelineColTimeOnSite: 'TimeOnSite',
      pipelineColHasAnomalies: 'HasAnomalies',
      pipelineColProfileActivityId: 'ProfileActivityId',
      pipelineColAnomalyName: 'AnomalyName',
      pipelineColTrackingDay: 'TrackingDay',
      pipelineComparePageTitle: 'Profile vs FaceScanner compare',
      pipelineComparePageHeading: 'Profile vs FaceScanner',
      pipelineCompareBreadcrumbSites: 'Sites',
      pipelineCompareBreadcrumbCurrent: 'Profile vs FaceScanner',
      pipelineCompareBackToSite: 'Back to site',
      pipelineCompareLoading: 'Loading…',
      pipelineCompareAccessDenied: 'You do not have permission to use this tool.',
      pipelineCompareSiteNotFound: 'Site not found.',
      pipelineCompareLoadSiteFailed: 'Failed to load site',
      pipelineCompareNavLabel: 'Profile vs FaceScanner (day compare)',
    },
    manageDoors: {
      title: 'Manage Doors',
      close: 'Close',
      unnamedDoor: 'Unnamed Door',
      deviceId: 'Device ID',
      openIn: 'Open In (15s)',
      openOut: 'Open Out (15s)',
      heldOpenAlert: 'Doors are held open',
      heldOpenAlertSince: 'Open since {time}',
      emptyTitle: 'No doors on this site',
      emptyDescription: 'Doors will appear here once they are configured for this site.',
      resetAll: 'Reset All Doors',
      successHoldOpenAll: 'All doors set to hold-open mode.',
      successResetAll: 'All doors were reset.',
      successOpenDoor: 'Door opened successfully.',
      failedLoadDoors: 'Failed to load doors.',
      failedHoldOpenAll: 'Failed to open all doors.',
      failedResetAll: 'Failed to reset all doors.',
      failedOpenDoor: 'Failed to open door.',
    },
  },

  // Reports
  reports: {
    noRecords: 'No records for the following report',
    exportCsv: 'Export CSV',
    exportPdf: 'Export PDF',
    exportPdfUnavailable: 'PDF export is currently unavailable for this report',
    details: 'Details',
    anomaly: 'ANOMALY',
    anomaliesDetected: 'Anomalies detected',
    onSite: 'ON SITE',
    entry: 'ENTRY',
    exit: 'EXIT',
    event: 'EVENT',
    peopleCount: '{count} people',
    group: 'Group',
    company: 'Company',
    totalTime: 'Total Time',
    filters: 'Filters',
    from: 'From',
    to: 'To',
    boscaAdminDaily: {
      presetToday: 'Today',
      presetYesterday: 'Yesterday',
      presetThisWeek: 'This week',
      presetLastWeek: 'Last week',
      presetThisMonth: 'This month',
      presetLastMonth: 'Last month',
      presetCustom: 'Custom',
      customFrom: 'From',
      customTo: 'To',
      profilesMatrixSubtitle:
        'Rows are profiles; columns are calendar days in the selected range. Each cell shows the total time on site that profile had that day (each column is only that day).',
      profilesMatrixSubtitleFlipped:
        'Rows are calendar days in the selected range; columns are profiles. Each cell shows the total time on site that profile had that day (each column is only that day).',
      companiesMatrixSubtitle:
        'Rows are companies; columns are calendar days. Each cell is how many distinct profiles from that firm had tracking that day (not a sum across the range).',
      matrixCaptionProfiles: '{profileCount} profiles × {dayCount} days',
      matrixCaptionCompanies: '{companyCount} companies × {dayCount} days',
      searchProfileMatrixPlaceholder: 'Search by profile, company, job',
      searchCompanyMatrixPlaceholder: 'Search by company name',
      columnProfile: 'Profile',
      columnCompany: 'Company',
      columnJobTitle: 'Job title',
      columnProfiles: 'Profiles',
      columnDate: 'Date',
      selectSiteWarning: 'Select a site (not "All") to load this report.',
      activityTimelineRequiresSingleDay:
        'Select a single day range to view the activity timeline.',
      dayCellPeopleHint: 'Distinct profiles from this company with tracking that day.',
      dayCellTimeHint: 'Total time on site that day for this company (sum of tracking records).',
      profileDayCellTimeHint: 'Total time on site that day for this profile.',
      exportCsvPeople: 'People',
      exportCsvTime: 'Time',
      flipAxisTooltip: 'Flip axis (swap rows and columns)',
      pdfDetailSite: 'Site',
      pdfDetailDateRange: 'Date range',
    },
  },

  // Procore
  procore: {
    title: 'Procore API Explorer',
    loadConfig: 'Load Config',
    saveConfig: 'Save Config',
    noConnectionConfigured: 'No Procore connection configured. Configure it in Account Settings.',
    configurationSaved: 'Configuration saved to database',
    failedSaveConfiguration: 'Failed to save configuration',
    configurationReloaded: 'Configuration reloaded from database',
    accessTokenRequired: 'Access Token is required (or configure connection in Account Settings)',
    companyIdRequired: 'Valid Company ID is required (or configure site mapping in Site Settings)',
    projectIdRequired: 'Valid Project ID is required (or configure site mapping in Site Settings)',
  },

  // Validation
  validation: {
    profilePictureRequired: 'Profile picture is required',
    profilePictureInvalid:
      'Profile picture data is invalid or empty. Please upload a valid picture.',
    profilePictureTooSmall:
      'Profile picture data is too small or invalid. Please upload a valid picture.',
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    firstNameRequired: 'First name is required',
    dateOfBirthRequired: 'Date of Birth is required',
    surnameRequired: 'Surname is required',
    phoneRequired: 'Phone number is required',
    companyRequired: 'Company is required',
    accessRequired: 'Access is required',
    roleRequired: 'Role is required',
    validFromAfterExpiresAt: 'Valid From date cannot be after Expires At date',
    expiresAtBeforeValidFrom: 'Expires At date cannot be before Valid From date',
  },

  // Data Grid
  dataGrid: {
    columns: 'Columns',
    toggleColumns: 'Toggle Columns',
    showAll: 'Show All',
    hideAll: 'Hide All',
    sortedAscending: 'sorted ascending',
    sortedDescending: 'sorted descending',
  },

  // Export PDF
  exportPdf: {
    generated: 'Generated',
    data: 'Data',
    noData: 'No data',
    emptyMessage: 'No data available for this report',
    yes: 'Yes',
    no: 'No',
    filters: 'Filters',
  },
}; 